//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NavDrawer from "./drawer";
import ViewsAvatar from "../components/avatar";
export default {
  components: {
    "nav-drawer": NavDrawer,
    "views-avatar": ViewsAvatar
  },
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      drawerTrigger: null,
      navBar: {},
      rightButtons: [] // on: false

    };
  },
  computed: {
    style: function style() {
      return Object.assign(this.genericStyles(this.navBar), this.leftPadding);
    },
    // We could've used the `app` attribute on `v-toolbar` if it didn't conflict with our header-footer css.
    leftPadding: function leftPadding() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
        case "xl":
          return {
            "padding-left": "270px"
          };

        default:
          return null;
      }
    },
    isPermanent: function isPermanent() {
      return this.leftPadding !== null;
    },
    showMobileMenu: function showMobileMenu() {
      return this.rightButtons.length > 0 && this.$vuetify.breakpoint.smAndDown;
    },
    mobileMenu: function mobileMenu() {
      return {
        icon: {
          material: {
            name: "mdi-dots-vertical"
          }
        },
        childButtons: this.rightButtons
      };
    }
  },
  methods: {
    $ready: function $ready() {
      this.navBar = this.page.navBar || {};
      this.rightButtons = this.navBar.rightButtons || [];
    },
    buttonSpec: function buttonSpec(item) {
      var styleClasses = (item.styleClasses || []).concat(item.text ? ["text"] : ["icon"]);
      return Object.assign({}, item, {
        view: "button-v1",
        styleClasses: styleClasses
      });
    },
    viewSourceEnabled: function viewSourceEnabled() {
      // return process.env.NODE_ENV === "development";
      return false;
    },
    viewSource: function viewSource() {
      var properties = {
        message: this.page
      };
      Utils.launch.dialog.open(Object.assign({}, properties));
    },
    avatarSpec: function avatarSpec(spec) {
      return {
        view: "avatar-v1",
        url: spec["imageUrl"],
        onClick: spec["onCLick"]
      };
    },
    cssClasses: function cssClasses() {
      if (this.navBar.view) {
        return this.$classes(this.navBar);
      } else {
        // This will execute initially when `this.navBar` has not been initialized (before `$ready()`)
        return {};
      }
    }
  }
};